import { render, staticRenderFns } from "./fadada-auth-callback.vue?vue&type=template&id=028d9822&scoped=true"
import script from "./fadada-auth-callback.vue?vue&type=script&lang=js"
export * from "./fadada-auth-callback.vue?vue&type=script&lang=js"
import style0 from "./fadada-auth-callback.vue?vue&type=style&index=0&id=028d9822&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d9822",
  null
  
)

export default component.exports